import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function SecuriteFenetresLyon() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-800 via-slate-700 to-gray-700 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-shield-check-line text-white"></i>
              <span className="text-white text-sm font-medium">Guide Sécurité 2025</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Sécurité Fenêtres Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Guide complet pour sécuriser vos fenêtres à Lyon. Vitrages anti-effraction, serrures renforcées et solutions pour protéger votre logement.
            </p>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Sécurité des Fenêtres à Lyon : Guide Complet 2025
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              À Lyon, comme dans toutes les grandes villes, la sécurité des fenêtres est une préoccupation majeure. Les cambriolages par les fenêtres représentent 30% des effractions. Ce guide vous présente toutes les solutions pour sécuriser efficacement vos fenêtres et protéger votre logement.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Statistiques Cambriolages à Lyon
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-alert-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>30% des cambriolages :</strong> Se font par les fenêtres et baies vitrées</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>80% des cambrioleurs :</strong> Abandonnent après 5 minutes de tentative</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Zones à risque :</strong> Rez-de-chaussée, 1er étage, maisons isolées</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Périodes sensibles :</strong> Vacances d'été et fêtes de fin d'année</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Vitrages de Sécurité
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Vitrage Feuilleté Anti-Effraction
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le vitrage feuilleté est composé de plusieurs couches de verre assemblées avec des films plastiques (PVB). En cas de choc, le verre se fissure mais reste en place, retardant considérablement l'intrusion. Classification : SP10 (retard 30 secondes), SP510 (retard 3 minutes), SP1010 (retard 5 minutes). Prix : 350€ à 600€ par fenêtre.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Vitrage Retardateur d'Effraction (VRE)
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le VRE offre une résistance maximale avec plusieurs couches de verre et de films. Résistance testée selon norme EN 356, retard d'effraction de 5 à 10 minutes, recommandé pour rez-de-chaussée et zones sensibles. Prix : 500€ à 800€ par fenêtre.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Vitrage Armé
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le vitrage armé intègre un treillis métallique dans le verre. Moins esthétique mais très résistant, idéal pour caves, garages et locaux techniques. Prix économique : 200€ à 350€ par fenêtre.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Systèmes de Verrouillage Renforcés
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-lock-2-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Crémone multipoints :</strong> 3 à 7 points de fermeture, résistance accrue (80€-150€)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lock-2-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Serrure à clé :</strong> Empêche l'ouverture de l'extérieur (60€-120€)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lock-2-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Poignée à clé :</strong> Blocage de la poignée en position fermée (40€-80€)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lock-2-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Gâches renforcées :</strong> Fixation solide dans la maçonnerie (30€-60€)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lock-2-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Verrous supplémentaires :</strong> Points de fermeture additionnels (25€-50€/pièce)</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Protections Physiques
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Volets Roulants Sécurisés
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les volets roulants constituent une excellente protection. Lames aluminium renforcées, verrous anti-soulèvement, motorisation avec détection d'obstacle, et système anti-arrachement. Prix : 400€ à 1200€ selon dimensions.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Grilles de Sécurité
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les grilles fixes ou amovibles offrent une protection maximale. Grilles fixes scellées dans la maçonnerie (300€-800€), grilles amovibles de l'intérieur (250€-600€), grilles décoratives en fer forgé (500€-1500€). Attention aux contraintes esthétiques dans le centre de Lyon.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Barres de Sécurité
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Solution discrète et efficace pour fenêtres oscillo-battantes. Barre télescopique bloquant l'ouverture (30€-60€), barre de seuil empêchant le forçage (40€-80€), facile à installer soi-même.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Systèmes d'Alarme et Détection
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-alarm-warning-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Détecteurs d'ouverture :</strong> Alarme si fenêtre ouverte (20€-50€/détecteur)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alarm-warning-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Détecteurs de bris de vitre :</strong> Alarme en cas de casse (30€-70€/détecteur)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alarm-warning-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Caméras de surveillance :</strong> Dissuasion et enregistrement (100€-400€/caméra)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alarm-warning-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Système d'alarme complet :</strong> Protection globale du logement (500€-2000€)</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Solutions par Type de Logement
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Rez-de-Chaussée et 1er Étage
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Zones les plus vulnérables nécessitant une protection maximale :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-shield-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Obligatoire :</strong> Vitrage feuilleté SP510 minimum + crémone multipoints</span>
              </li>
              <li className="flex items-start">
                <i className="ri-shield-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Recommandé :</strong> Volets roulants sécurisés ou grilles</span>
              </li>
              <li className="flex items-start">
                <i className="ri-shield-check-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Complément :</strong> Détecteurs d'ouverture et caméras</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Appartement en Étage
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Risque moindre mais protection conseillée :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-shield-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Minimum :</strong> Poignée à clé + détecteurs d'ouverture</span>
              </li>
              <li className="flex items-start">
                <i className="ri-shield-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Recommandé :</strong> Vitrage feuilleté SP10 pour baies vitrées</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Maison Individuelle
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Protection complète de toutes les ouvertures :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-home-gear-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Toutes fenêtres :</strong> Vitrage feuilleté + crémone multipoints</span>
              </li>
              <li className="flex items-start">
                <i className="ri-home-gear-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Volets :</strong> Motorisés avec sécurité renforcée</span>
              </li>
              <li className="flex items-start">
                <i className="ri-home-gear-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Alarme :</strong> Système complet avec télésurveillance</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Normes et Certifications
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-medal-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Norme EN 356 :</strong> Classification des vitrages anti-effraction (P1A à P8B)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-medal-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Label A2P :</strong> Certification CNPP pour serrures et vitrages</span>
              </li>
              <li className="flex items-start">
                <i className="ri-medal-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Norme NF :</strong> Garantie de qualité et de performance</span>
              </li>
              <li className="flex items-start">
                <i className="ri-medal-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Certification Cekal :</strong> Pour vitrages isolants et de sécurité</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Budget Sécurisation à Lyon
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Protection basique :</strong> 150€-300€/fenêtre (poignée à clé + détecteurs)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Protection standard :</strong> 400€-700€/fenêtre (vitrage feuilleté + crémone)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Protection renforcée :</strong> 800€-1500€/fenêtre (VRE + volets sécurisés)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Alarme complète :</strong> 500€-2000€ pour tout le logement</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Aides et Réductions d'Assurance
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-gift-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Crédit d'impôt :</strong> Possible pour certains équipements de sécurité</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Réduction assurance :</strong> 5% à 15% sur la prime habitation</span>
              </li>
              <li className="flex items-start">
                <i className="ri-gift-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Aides locales :</strong> Renseignez-vous auprès de la Ville de Lyon</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conseils Pratiques
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Simulez une présence :</strong> Programmateurs pour lumières et volets</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Éclairage extérieur :</strong> Détecteurs de mouvement dissuasifs</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Voisinage vigilant :</strong> Participez aux réseaux de surveillance de quartier</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Végétation :</strong> Taillez les haies pour limiter les cachettes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-slate-700 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Réseaux sociaux :</strong> Ne signalez pas vos absences publiquement</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              La sécurisation des fenêtres est un investissement essentiel à Lyon. Une protection adaptée à votre situation (type de logement, étage, quartier) réduit considérablement les risques de cambriolage. Privilégiez une approche globale combinant vitrage de sécurité, systèmes de verrouillage renforcés et détection. N'oubliez pas que 80% des cambrioleurs abandonnent après 5 minutes : chaque obstacle compte !
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
